import { type FC } from "react";

import { clsx } from "clsx";
import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

import snapchatGhostSvg from "@app-assets/svg/snapchat.svg";

import { type AssistantChatMessageModel } from "../model";

import styles from "./AssistantChatMessageItem.module.css";
import { AssistantChatSources } from "./AssistantChatSources";

interface Props {
    message: AssistantChatMessageModel;
}

const markdownComponents: Components = {
    a: ({ node: _node, children, ...props }) => (
        <a {...props} target="_blank" rel="noopener noreferrer">
            {children}
        </a>
    ),
};

export const AssistantMessageItem: FC<Props> = ({ message }) => (
    <div className={clsx(styles.row, styles.assistant)}>
        <img className={styles.avatar} src={snapchatGhostSvg} alt="" />
        <div className={styles.assistantText}>
            <div className={styles.markdown}>
                <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
                    {message.text}
                </ReactMarkdown>
            </div>
            {message.sources && message.sources.length > 0 && <AssistantChatSources sources={message.sources} />}
        </div>
    </div>
);
